import React from 'react';
import { observer } from "mobx-react";

import { Upload, Alert, Typography, Button, Icon } from 'antd';

import { ShippingItemStoreContext } from './AppContexts';


@observer
class UploadData extends React.Component {
	static contextType = ShippingItemStoreContext;

	state = { showAlert: false, uploadSuccess: false, uploadWarnings: [], uploadError: '', uploadCount: 0 };

	constructor(props) {
		super(props);

		// This binding is necessary to make `this` work in the callback
		this.uploadStatusChange = this.uploadStatusChange.bind(this);
	}

	uploadStatusChange({ file, fileList, event }) {
		console.log(file.status, file);
		if (file.status == 'uploading'){
			if (this.state.showAlert){
				this.setState({ showalert: false });
			}
		}
		else if (file.status == 'error'){
			this.setState({ uploadSuccess: false });
			if (typeof file.response == 'object'){
				if (file.response.err){
					this.setState({ uploadError: file.response.err || '', uploadCount: 0 });
				}
			} else {
				this.setState({ uploadError: 'Errore: nessuna risposta dal server', uploadCount: 0 });
			}
			this.setState({ showAlert: true });
		}
		else if (file.status == 'done'){
			console.log('file uploaded');
			if (typeof file.response == 'object'){
				if (file.response.stat == 'ok'){
					this.setState({ uploadSuccess: true, uploadCount: file.response.count });
				}
				else if (file.response.stat == 'ko'){
					this.setState({ uploadSuccess: false, uploadError: file.response.err || '', uploadCount: 0 });
				}
				this.setState({ uploadWarnings: file.response.warnings || [] });
			}
			this.setState({ showAlert: true });
			this.context.setDirty();
		}
	}

	render() {
		let authHeaders = this.context.auth.getAuthHeaders();

		let alertBlock = null;
		let warnings = (
			<div>
				{ this.state.uploadCount == 0 ? <div>No ShippingItems were created</div> : null }
				{ this.state.uploadWarnings.map( (item, cnt) => (<div key={cnt}>{item}</div>) ) }
			</div>
		);
		if (this.state.showAlert){
			if (!this.state.uploadSuccess){
				let error = <div>{ this.state.uploadError }</div>;
				alertBlock = (<Alert message="Errore"
			 			description={ (
							<div>
								{ error }
								<br/>
								{ warnings }
							</div>
						) }
			 			type="error"
						showIcon />);
			}
			else if (this.state.uploadWarnings.length == 0 && this.state.uploadCount > 0){ //uploadSuccess is true here
				alertBlock = (<Alert message="Perfetto"
			 			description={`Il caricamento è riuscito. ${this.state.uploadCount} colli sono stati importati.`}
			 			type="success"
						showIcon />);
			}
			else {
				alertBlock = (<Alert message="Il caricamento è riuscito ma ci sono alcune segnalazioni"
			 			description={ warnings }
			 			type="warning"
						showIcon />);
			}
		}

		return (
		<>
			<Typography.Title level={3}>Importa Excel</Typography.Title>
			<Typography.Paragraph className='text-left'>
				Carica un Excel correttamente formattato per importare più Colli in una sola volta.<br/>
				Ricordati che i numeri decimali vanno separati dal "." (punto) e non dalla virgola.
			</Typography.Paragraph>
			<Upload name='file' action={this.context.uploadAction} headers={this.authHeaders} onChange={this.uploadStatusChange} onPreview={this.onPreview}>
				<Button type="primary">
					<Icon type="upload" /> Carica Excel
				</Button>
			</Upload>
			<br/>
			{ alertBlock }
			<br/>
			<div><Button href={`/download/ricciardi-template2020.xlsx?rnd=${String(Math.random()).slice(2)}`} target="_blank" download="ricciardi-template.xlsx" icon="file-excel">Scarica il modello Excel</Button></div>
		</>);
	}
}

export { UploadData };
